import { Component, OnInit } from '@angular/core';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import * as moment from 'moment'
import { ExamService } from 'src/app/services/Exam/exam.service';


@Component({
  selector: 'app-admit-card',
  templateUrl: './admit-card.component.html',
  styleUrls: ['./admit-card.component.css']
})
export class AdmitCardComponent implements OnInit {

  ClassSectionList: any;

  constructor(private admitservice: ExamService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  ExamAdmitCardModel = {
    ClassSectionID: '',
    IsSelect: false,
    ClassID: 0,
    SectionID: 0,
    TermID: 0,
    ExamMapID: 0,
  }

  Reset() {
    this.ExamAdmitCardModel.ClassSectionID = '';
    this.ExamAdmitCardModel.ClassID = 0;
    this.ExamAdmitCardModel.SectionID = 0;
    this.ExamAdmitCardModel.TermID = 0;
    this.ExamAdmitCardModel.ExamMapID = 0;
    this.StudentList = [];
    this.Submitted = false;
  };

  SetID() {
    this.StudentList = [];
    this.ExamAdmitCardModel.ClassID = 0;
    this.ExamAdmitCardModel.SectionID = 0;
    if (this.ExamAdmitCardModel.ClassSectionID != '' || this.ExamAdmitCardModel.ClassSectionID != null) {
      var strClassSectionID = this.ExamAdmitCardModel.ClassSectionID.split('-');
      this.ExamAdmitCardModel.ClassID = parseInt(strClassSectionID[0]);
      this.ExamAdmitCardModel.SectionID = parseInt(strClassSectionID[1]);
      this.GetTerm();
    }

  }

  onSelect(item) {
    this.StudentList = [];
    this.ExamAdmitCardModel.ClassID = item.ClassID;
    this.ExamAdmitCardModel.SectionID = item.SectionID;
    this.GetTerm();

  }
  ValidateDropdown() {
    return this.ExamAdmitCardModel.ClassID == 0 || this.ExamAdmitCardModel.TermID == 0 || this.ExamAdmitCardModel.ExamMapID == 0;
  };
  StudentList = [];
  Submitted = false;
  GetStudentAdmitCard() {
    this.Submitted = true;
    this.StudentList = [];
    if (!this.ValidateDropdown()) {
      this.spinnerService.show();
      this.admitservice.GetStudentAdmitCard(JSON.stringify(this.ExamAdmitCardModel)).subscribe((data: any) => {
        this.StudentList = data.StudentList;
        this.spinnerService.hide();

      });
    }
  };





  ngOnInit() {
    this.GetAllClass();
  }

  GetAllClass() {
    this.lookupservice.GetLookupsList('AllClassSection', '').subscribe((data: any) => {
      this.ClassSectionList = data.LookupItems;
      this.ClassSectionList.splice(0, 1);
    });
  };
  TermList = [];
  GetTerm() {
    this.TermList = [];
    this.StudentList = [];
    this.ExamAdmitCardModel.TermID = 0;
    this.ExamAdmitCardModel.ExamMapID = 0;
    var ItemBo = {
      ItemId: this.ExamAdmitCardModel.ClassID
    }
    this.lookupservice.GetLookupsList('ExamTerm', JSON.stringify(ItemBo)).subscribe((data) => {
      this.TermList = data.LookupItems;

    });
  };
  ExamMasterList = [];
  GetExamMaster() {
    this.spinnerService.show();
    this.StudentList = [];
    this.ExamMasterList = [];
    this.ExamAdmitCardModel.ExamMapID = 0;
    var item = {
      ItemId: this.ExamAdmitCardModel.ClassID,
      ItemId2: this.ExamAdmitCardModel.TermID
    }
    this.lookupservice.GetLookupsList('ExamEntry', JSON.stringify(item)).subscribe((data) => {
      this.ExamMasterList = data.LookupItems;
      this.spinnerService.hide();

    });
  };
  Count1 = 0;
  PrintButton = false;
  IsSelect = false;
  ChangeSelect(item) {
    this.Count1 = 0;
    for (var i = 0; i < this.StudentList.length; i++) {
      if (this.StudentList[i].IsActive) {
        this.Count1 = this.Count1 + 1
        this.PrintButton = false;
      }
    }
    if (this.Count1 == this.StudentList.length) {
      this.IsSelect = true;
      this.PrintButton = false;
    }
    else {
      this.IsSelect = false;
    }

  }
  AllPrint(item) {

  }
  SelectAll() {
    if (this.IsSelect) {
      for (var i = 0; i < this.StudentList.length; i++) {
        this.StudentList[i].IsActive = true;
        this.PrintButton = false;
      }
    }
    if (this.IsSelect == false) {
      for (var i = 0; i < this.StudentList.length; i++) {
        this.StudentList[i].IsActive = false;
        this.PrintButton = true;
      }
    }
  }
  
  // Print Admit Card

  PrintAdmitCard(item, PrintType) {
    var url = url = "print-admit-card?StudentID=" + item.StudentID + "&ClassID=" + this.ExamAdmitCardModel.ClassID + "&ExamMapID=" + this.ExamAdmitCardModel.ExamMapID + "&PrintType=" + PrintType;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
  };
}
